import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = createClient({
    projectId: 'nq0sp2jo',
    dataset: 'production',
    useCdn: true,
    apiVersion: '2024-06-29',
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);